import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown/Dropdown.js";
import { Icon, ICON_NAMES } from "../Icon";
import { NO_RESULTS } from "../../../utils/default-strings";
import { adaptOnChange } from "./utils/adaptOnChange";
import { adaptOptions } from "./utils/adaptOptions";
import { getMinWidth } from "./utils/getMinWidth";
export var Component = function Component(_ref) {
  var children = _ref.children,
      isMenuItem = _ref.isMenuItem,
      isSearchable = _ref.isSearchable,
      isTriggeredOnHover = _ref.isTriggeredOnHover,
      isTriggerUnderlined = _ref.isTriggerUnderlined,
      items = _ref.items,
      name = _ref.name,
      noResultsText = _ref.noResultsText,
      onChange = _ref.onChange,
      pointing = _ref.pointing,
      value = _ref.value,
      willOpenAbove = _ref.willOpenAbove;
  return React.createElement(Dropdown, {
    className: isTriggerUnderlined ? 'underlined' : '',
    icon: React.createElement(Icon, {
      name: ICON_NAMES.CARET_DOWN,
      size: "small"
    }),
    item: isMenuItem,
    name: name,
    noResultsMessage: noResultsText,
    onChange: adaptOnChange(onChange, name),
    options: adaptOptions(items),
    pointing: pointing,
    scrolling: true,
    search: isSearchable,
    simple: isTriggeredOnHover,
    style: getMinWidth(isSearchable, items),
    trigger: children,
    upward: willOpenAbove,
    value: value
  });
};
Component.displayName = 'Submenu';
Component.defaultProps = {
  children: null,
  isMenuItem: false,
  isSearchable: false,
  isTriggeredOnHover: false,
  isTriggerUnderlined: false,
  name: null,
  noResultsText: NO_RESULTS,
  onChange: Function.prototype,
  pointing: 'top left',
  value: null,
  willOpenAbove: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  isMenuItem: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isTriggerUnderlined: PropTypes.bool,
  isTriggeredOnHover: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    target: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })).isRequired,
  name: PropTypes.string,
  noResultsText: PropTypes.string,
  onChange: PropTypes.func,
  pointing: PropTypes.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right']),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  willOpenAbove: PropTypes.bool
} : {};